<div class="person-notification">
  <div class="person-notification__content">
    <app-header />

    <div class="person-notification__main">
      <section class="person-notification__hero" aria-labelledby="person-notification-title">
        <h1 id="person-notification-title" class="person-notification__title">
          Veuillez saisir le nom de la personne à notifier<br />
          de votre présence
        </h1>
      </section>

      <section class="person-notification__panels" aria-label="Recherche et résultats">
        <div class="person-notification__panel person-notification__panel--search">
          <div
            class="person-notification__search-field"
            role="search"
            aria-label="Recherche par nom"
          >
            <span class="person-notification__search-value">{{ searchQuery() }}</span>
            <span class="person-notification__search-caret" aria-hidden="true"></span>
          </div>

          <app-virtual-keyboard
            [showNumberRow]="false"
            [showValidateButton]="false"
            (keyPress)="onKeyPress($event)"
            (backspace)="onBackspace()"
            (space)="onSpace()"
          />
        </div>

        <div class="person-notification__panel person-notification__panel--results">
          <ul class="person-notification__results" role="listbox" aria-label="Personnes trouvées">
            @for (contact of filteredContacts(); track contact.id) {
              <li class="person-notification__results-item" role="presentation">
                <button
                  type="button"
                  class="person-notification__result"
                  role="option"
                  [attr.aria-selected]="selectedPersonId() === contact.id"
                  [class.person-notification__result--selected]="selectedPersonId() === contact.id"
                  (click)="selectPerson(contact.id)"
                >
                  {{ contact.displayName }}
                </button>
              </li>
            } @empty {
              <li class="person-notification__results-empty" role="status">
                Aucune personne trouvée
              </li>
            }
          </ul>
        </div>
      </section>
    </div>

    <app-footer>
      <app-footer-nav [showScrollButton]="false" backRoute="/appointment-choice" />
    </app-footer>
  </div>
</div>
